import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {LetterSubscriber} from '../models/letter-subscriber';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LetterSubscriberService {

  public objectImage: any = null;

  constructor (
    private db: AngularFirestore,
    private fs: AngularFireStorage,
  ) { }

  getById (id: any) {
    return this.db.doc<LetterSubscriber>('sbccv_subscribers/' + id)
      .get();
  }

  select (event_id: any) {
    return this.db.collection<LetterSubscriber>('sbccv_subscribers', ref => ref
      .where("deleted", "==", false)
      .where("event_id", "==", event_id)
      .orderBy('name', 'asc')).snapshotChanges();
  }

  selectByContext (context_id: any) {
    return this.db.collection<LetterSubscriber>('sbccv_subscribers', ref => ref
      .where("deleted", "==", false)
      .where("context_id", "==", context_id)
      .orderBy('name', 'asc')).snapshotChanges();
  }

  selectByEvent (event_id: any) {
    return this.db.collection<LetterSubscriber>('sbccv_subscribers', ref => ref
      .where("deleted", "==", false)
      .where("event_id", "==", event_id)
      .orderBy('name', 'asc')).snapshotChanges();
  }

  insert (entity: LetterSubscriber) {
    return this.db.collection('sbccv_subscribers').add(Object.assign({}, entity));
  }

  async update (entity: LetterSubscriber) {
    let id = entity.id;
    await this.db.collection('sbccv_subscribers').doc(id).set(Object.assign({}, entity), {'merge': true});
    if (this.objectImage) {
      return this.uploadImage(this.objectImage, id);
    }
  }

  uploadImage (file, letter_id) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/subscribers/letters/" + letter_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(letter_id, url)
        });
      }))
      .subscribe();
  }

  async updateImage (letter_id: any, image: any) {
    try {
      await this.db.collection('sbccv_subscribers').doc(letter_id).set({image_url: image}, {merge: true});
      this.objectImage = "";
    } catch (err) {
      console.log("erro upadate image: " + JSON.stringify(err));
    }
  }

  deleteLetter (id: any) {
    return this.db.collection('sbccv_subscribers').doc(id).set({'deleted': true}, {'merge': true});
  }

  createLetter (data: any): LetterSubscriber {
    return {
      id: data.id,
      name: data.name,
      subject: data.subject,
      type: data.type,
      text: data.text,
      text_back: data.text_back,
      context_id: data.context_id,
      // event_id: data.event_id,
      // event_name: data.event_name,
      image_url: data.image_url,
      deleted: false,
    }
  }


  insertEmailSent (key: any, entity: any) {
    return this.db.collection('sbccv_subscribers_sent').doc(key).set(Object.assign({}, entity));
  }

  selectSent (event_id: any, letter_id: any) {
    return this.db.collection<any>('sbccv_subscribers_sent', ref => ref
      .where("event_id", "==", event_id)
      .where("letter_id", "==", letter_id)
    ).snapshotChanges();
  }

  deleteSent (id: any) {
    return this.db.collection('sbccv_subscribers_sent').doc(id).delete();
  }

  getSentById (id: any) {
    return this.db.doc<any>('sbccv_subscribers_sent/' + id)
      .get();
  }


  updateSent (id: any, flag: boolean) {
    const responseDate = new Date();
    return this.db.collection('sbccv_subscribers_sent').doc(id)
    .set({'refuse': flag, 'responseDate': responseDate}, {'merge': true});
  }

}
